export enum GraphqlErrorCode {
  UndefinedField = 'undefinedField',
  SelectionMismatch = 'selectionMismatch',
}
